import create from "zustand";
import { devtools, persist } from "zustand/middleware";
import {
  initialAlgoSignerWalletConnectorState,
  AlgoSignerWalletConnectorState,
  AlgoSignerWalletConnectorActions,
} from "../walletConnectorInterfaces";

export const useAlgoSignerWalletConnector = create<
  AlgoSignerWalletConnectorState & AlgoSignerWalletConnectorActions
>()(
  devtools(
    persist(
      (set) => ({
        ...initialAlgoSignerWalletConnectorState,
        catchAlgoSignerWalletConnectError: (error: any) => {
          set((state) => ({
            ...state,
            error: error,
          }));
        },
        algoSignerConnectWallet: (ledger: string) => {
          set((state) => ({
            ...state,
            isAlgoConnecting: true,
            isAlgoConnected: false,
            error: "",
            currentLedger: ledger,
            algoSdk: undefined,
            isAlgosignerInitialized: false,
          }));
        },
        connectAlgorandWalletAddress: (
          connectedAlgorandWalletAddress: string
        ) => {
          set((state) => ({ ...state, connectedAlgorandWalletAddress }));
        },
        algoSignerWalletConnected: (walletAddresses: any[], algoSdk: any) => {
          set((state) => ({
            ...state,
            isAlgoConnecting: false,
            isAlgoConnected: true,
            walletAddresses: walletAddresses,
            error: "",
            algoSdk: algoSdk,
            isAlgoSignerInitialized: true,
          }));
        },
        resetAlgoSignerWalletConnector: () => {
          set(() => ({
            ...initialAlgoSignerWalletConnectorState,
          }));
        },
      }),
      {
        name: "algoSignerWalletConnector",
        getStorage: () => sessionStorage,
        partialize: (state) => ({
          isAlgoConnected: state.isAlgoConnected,
          walletAddresses: state.walletAddresses,
          connectedAlgorandWalletAddress: state.connectedAlgorandWalletAddress,
          currentLedger: state.currentLedger,
        }),
      }
    )
  )
);
